export enum PC_EMAIL_RECIPIENT {
  DEFAULT = 'cockpit@pluscity.at',
  SALES = 'umsatz@plus-city.at',
}
